/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonAddress,
    JsonAddressFromJSON,
    JsonAddressFromJSONTyped,
    JsonAddressToJSON,
} from './JsonAddress';
import {
    JsonErrorInfo,
    JsonErrorInfoFromJSON,
    JsonErrorInfoFromJSONTyped,
    JsonErrorInfoToJSON,
} from './JsonErrorInfo';
import {
    JsonEventPartyArticle,
    JsonEventPartyArticleFromJSON,
    JsonEventPartyArticleFromJSONTyped,
    JsonEventPartyArticleToJSON,
} from './JsonEventPartyArticle';
import {
    JsonFindPartyResponse,
    JsonFindPartyResponseFromJSON,
    JsonFindPartyResponseFromJSONTyped,
    JsonFindPartyResponseToJSON,
} from './JsonFindPartyResponse';
import {
    JsonPartyEventDetails,
    JsonPartyEventDetailsFromJSON,
    JsonPartyEventDetailsFromJSONTyped,
    JsonPartyEventDetailsToJSON,
} from './JsonPartyEventDetails';
import {
    JsonPartyInfo,
    JsonPartyInfoFromJSON,
    JsonPartyInfoFromJSONTyped,
    JsonPartyInfoToJSON,
} from './JsonPartyInfo';

/**
 * 
 * @export
 * @interface JsonEventPartyImport
 */
export interface JsonEventPartyImport {
    /**
     * 
     * @type {Array<string>}
     * @memberof JsonEventPartyImport
     */
    allowedActions?: Array<JsonEventPartyImportAllowedActionsEnum>;
    /**
     * 
     * @type {Array<JsonEventPartyArticle>}
     * @memberof JsonEventPartyImport
     */
    articles?: Array<JsonEventPartyArticle>;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyImport
     */
    bankAccount?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyImport
     */
    birthDate?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyImport
     */
    cebId?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyImport
     */
    companyId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyImport
     */
    companyName?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyImport
     */
    companyNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyImport
     */
    createdAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyImport
     */
    createdBy?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyImport
     */
    email?: string;
    /**
     * 
     * @type {Array<JsonPartyEventDetails>}
     * @memberof JsonEventPartyImport
     */
    eventDetails?: Array<JsonPartyEventDetails>;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyImport
     */
    firstName?: string;
    /**
     * 
     * @type {Array<JsonFindPartyResponse>}
     * @memberof JsonEventPartyImport
     */
    foundParties?: Array<JsonFindPartyResponse>;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyImport
     */
    fullName?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyImport
     */
    groupId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyImport
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyImport
     */
    note?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyImport
     */
    orgCompanyName?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyImport
     */
    partyId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyImport
     */
    partyType?: JsonEventPartyImportPartyTypeEnum;
    /**
     * 
     * @type {JsonAddress}
     * @memberof JsonEventPartyImport
     */
    permAddress?: JsonAddress;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyImport
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyImport
     */
    photoGuid?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyImport
     */
    photoId?: number;
    /**
     * 
     * @type {JsonPartyInfo}
     * @memberof JsonEventPartyImport
     */
    resultParty?: JsonPartyInfo;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyImport
     */
    roleId?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyImport
     */
    rowNo?: number;
    /**
     * 
     * @type {Array<JsonErrorInfo>}
     * @memberof JsonEventPartyImport
     */
    saveErrors?: Array<JsonErrorInfo>;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyImport
     */
    sex?: JsonEventPartyImportSexEnum;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyImport
     */
    siwiFirstName?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyImport
     */
    siwiId?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyImport
     */
    siwiLastName?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyImport
     */
    siwiPhotoGuid?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyImport
     */
    siwiPhotoId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyImport
     */
    siwiPropFirstName?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyImport
     */
    siwiPropLastName?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyImport
     */
    siwiStatus?: JsonEventPartyImportSiwiStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyImport
     */
    siwiSyncStatus?: JsonEventPartyImportSiwiSyncStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyImport
     */
    siwiUpdatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyImport
     */
    siwiUpdatedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyImport
     */
    status?: JsonEventPartyImportStatusEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof JsonEventPartyImport
     */
    tags?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyImport
     */
    updatedAt?: string;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyImport
     */
    updatedBy?: number;
    /**
     * 
     * @type {number}
     * @memberof JsonEventPartyImport
     */
    userId?: number;
    /**
     * 
     * @type {string}
     * @memberof JsonEventPartyImport
     */
    userStatus?: JsonEventPartyImportUserStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum JsonEventPartyImportAllowedActionsEnum {
    View = 'VIEW',
    Edit = 'EDIT'
}/**
* @export
* @enum {string}
*/
export enum JsonEventPartyImportPartyTypeEnum {
    Fo = 'FO',
    Po = 'PO',
    T = 'T'
}/**
* @export
* @enum {string}
*/
export enum JsonEventPartyImportSexEnum {
    M = 'M',
    F = 'F'
}/**
* @export
* @enum {string}
*/
export enum JsonEventPartyImportSiwiStatusEnum {
    Deleted = 'DELETED',
    Active = 'ACTIVE'
}/**
* @export
* @enum {string}
*/
export enum JsonEventPartyImportSiwiSyncStatusEnum {
    None = 'NONE',
    Synced = 'SYNCED',
    Dirty = 'DIRTY',
    Pushing = 'PUSHING',
    Conflict = 'CONFLICT',
    Error = 'ERROR'
}/**
* @export
* @enum {string}
*/
export enum JsonEventPartyImportStatusEnum {
    Deleted = 'DELETED',
    Active = 'ACTIVE'
}/**
* @export
* @enum {string}
*/
export enum JsonEventPartyImportUserStatusEnum {
    Deleted = 'DELETED',
    Active = 'ACTIVE',
    New = 'NEW'
}

export function JsonEventPartyImportFromJSON(json: any): JsonEventPartyImport {
    return JsonEventPartyImportFromJSONTyped(json, false);
}

export function JsonEventPartyImportFromJSONTyped(json: any, ignoreDiscriminator: boolean): JsonEventPartyImport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'allowedActions': !exists(json, 'allowedActions') ? undefined : json['allowedActions'],
        'articles': !exists(json, 'articles') ? undefined : ((json['articles'] as Array<any>).map(JsonEventPartyArticleFromJSON)),
        'bankAccount': !exists(json, 'bankAccount') ? undefined : json['bankAccount'],
        'birthDate': !exists(json, 'birthDate') ? undefined : json['birthDate'],
        'cebId': !exists(json, 'cebId') ? undefined : json['cebId'],
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'companyName': !exists(json, 'companyName') ? undefined : json['companyName'],
        'companyNumber': !exists(json, 'companyNumber') ? undefined : json['companyNumber'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'eventDetails': !exists(json, 'eventDetails') ? undefined : ((json['eventDetails'] as Array<any>).map(JsonPartyEventDetailsFromJSON)),
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'foundParties': !exists(json, 'foundParties') ? undefined : ((json['foundParties'] as Array<any>).map(JsonFindPartyResponseFromJSON)),
        'fullName': !exists(json, 'fullName') ? undefined : json['fullName'],
        'groupId': !exists(json, 'groupId') ? undefined : json['groupId'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'orgCompanyName': !exists(json, 'orgCompanyName') ? undefined : json['orgCompanyName'],
        'partyId': !exists(json, 'partyId') ? undefined : json['partyId'],
        'partyType': !exists(json, 'partyType') ? undefined : json['partyType'],
        'permAddress': !exists(json, 'permAddress') ? undefined : JsonAddressFromJSON(json['permAddress']),
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'photoGuid': !exists(json, 'photoGuid') ? undefined : json['photoGuid'],
        'photoId': !exists(json, 'photoId') ? undefined : json['photoId'],
        'resultParty': !exists(json, 'resultParty') ? undefined : JsonPartyInfoFromJSON(json['resultParty']),
        'roleId': !exists(json, 'roleId') ? undefined : json['roleId'],
        'rowNo': !exists(json, 'rowNo') ? undefined : json['rowNo'],
        'saveErrors': !exists(json, 'saveErrors') ? undefined : ((json['saveErrors'] as Array<any>).map(JsonErrorInfoFromJSON)),
        'sex': !exists(json, 'sex') ? undefined : json['sex'],
        'siwiFirstName': !exists(json, 'siwiFirstName') ? undefined : json['siwiFirstName'],
        'siwiId': !exists(json, 'siwiId') ? undefined : json['siwiId'],
        'siwiLastName': !exists(json, 'siwiLastName') ? undefined : json['siwiLastName'],
        'siwiPhotoGuid': !exists(json, 'siwiPhotoGuid') ? undefined : json['siwiPhotoGuid'],
        'siwiPhotoId': !exists(json, 'siwiPhotoId') ? undefined : json['siwiPhotoId'],
        'siwiPropFirstName': !exists(json, 'siwiPropFirstName') ? undefined : json['siwiPropFirstName'],
        'siwiPropLastName': !exists(json, 'siwiPropLastName') ? undefined : json['siwiPropLastName'],
        'siwiStatus': !exists(json, 'siwiStatus') ? undefined : json['siwiStatus'],
        'siwiSyncStatus': !exists(json, 'siwiSyncStatus') ? undefined : json['siwiSyncStatus'],
        'siwiUpdatedAt': !exists(json, 'siwiUpdatedAt') ? undefined : json['siwiUpdatedAt'],
        'siwiUpdatedBy': !exists(json, 'siwiUpdatedBy') ? undefined : json['siwiUpdatedBy'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'tags': !exists(json, 'tags') ? undefined : json['tags'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'updatedBy': !exists(json, 'updatedBy') ? undefined : json['updatedBy'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'userStatus': !exists(json, 'userStatus') ? undefined : json['userStatus'],
    };
}

export function JsonEventPartyImportToJSON(value?: JsonEventPartyImport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'allowedActions': value.allowedActions,
        'articles': value.articles === undefined ? undefined : ((value.articles as Array<any>).map(JsonEventPartyArticleToJSON)),
        'bankAccount': value.bankAccount,
        'birthDate': value.birthDate,
        'cebId': value.cebId,
        'companyId': value.companyId,
        'companyName': value.companyName,
        'companyNumber': value.companyNumber,
        'createdAt': value.createdAt,
        'createdBy': value.createdBy,
        'email': value.email,
        'eventDetails': value.eventDetails === undefined ? undefined : ((value.eventDetails as Array<any>).map(JsonPartyEventDetailsToJSON)),
        'firstName': value.firstName,
        'foundParties': value.foundParties === undefined ? undefined : ((value.foundParties as Array<any>).map(JsonFindPartyResponseToJSON)),
        'fullName': value.fullName,
        'groupId': value.groupId,
        'lastName': value.lastName,
        'note': value.note,
        'orgCompanyName': value.orgCompanyName,
        'partyId': value.partyId,
        'partyType': value.partyType,
        'permAddress': JsonAddressToJSON(value.permAddress),
        'phone': value.phone,
        'photoGuid': value.photoGuid,
        'photoId': value.photoId,
        'resultParty': JsonPartyInfoToJSON(value.resultParty),
        'roleId': value.roleId,
        'rowNo': value.rowNo,
        'saveErrors': value.saveErrors === undefined ? undefined : ((value.saveErrors as Array<any>).map(JsonErrorInfoToJSON)),
        'sex': value.sex,
        'siwiFirstName': value.siwiFirstName,
        'siwiId': value.siwiId,
        'siwiLastName': value.siwiLastName,
        'siwiPhotoGuid': value.siwiPhotoGuid,
        'siwiPhotoId': value.siwiPhotoId,
        'siwiPropFirstName': value.siwiPropFirstName,
        'siwiPropLastName': value.siwiPropLastName,
        'siwiStatus': value.siwiStatus,
        'siwiSyncStatus': value.siwiSyncStatus,
        'siwiUpdatedAt': value.siwiUpdatedAt,
        'siwiUpdatedBy': value.siwiUpdatedBy,
        'status': value.status,
        'tags': value.tags,
        'updatedAt': value.updatedAt,
        'updatedBy': value.updatedBy,
        'userId': value.userId,
        'userStatus': value.userStatus,
    };
}

